/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
/* eslint-disable jsx-a11y/anchor-is-valid  */
import React, { useState, useRef, useMemo, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { generatePath, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import routes from 'config/common/routes';
import { Container, Carousel, Image, Button, Trigger, CustomImageDot, TriggerCinemaRentInfo } from 'app/components';
import { Title, CinemaRentWrapper, Expander, FaqItem, GiftcardExpander } from './styles';

const sliderPropsConfig = () => ({
  slidesToSlide: 1,
  showDots: true,
  ssr: true,
  partialVisible: true,
  autoPlay: true,
  autoPlaySpeed: 4000,
  infinite: true,
  responsive: {
    desktop: {
      breakpoint: {
        max: 30000,
        min: 0
      },
      items: 1
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  }
});

const propTypes = {
  cinemaRentDetails: PropTypes.oneOf([PropTypes.array, PropTypes.any]),
  getCinemaRentDetails: PropTypes.func.isRequired
};

const defaultProps = {
  cinemaRentDetails: []
};

const CinemaRent = ({ cinemaRentDetails, getCinemaRentDetails }) => {
  const sliderRef = useRef(null);
  const [t, i18n] = useTranslation();
  const { language } = i18n;

  const [rentDetails, setRentDetails] = useState({
    headline1: '',
    headline1EN: '',
    galleryPictures: [],
    description: '',
    descriptionEN: '',
    headline2: '',
    headline2EN: '',
    faq: [],
    headline3: '',
    Headline3EN: '',
    description3: '',
    description3EN: '',
    picture3: '',
    headlinePartner: '',
    headlinePartnerEN: '',
    partnerImage: '',
    aGBLinktext: '',
    aGBLinktextEN: '',
    aGBPDF: '',
    b2BLinktext: '',
    b2BLinktextEN: '',
    b2BPDF: ''
  });

  const [isExpanded, setIsExpanded] = useState([]);
  const [giftcardsExpanded, setGiftcardsExpanded] = useState(false);

  const restrictedCountries = ["svn", "rks", "mne", "alb", "hrv"];

  useEffect(() => {
    getCinemaRentDetails();
  }, []);

  useEffect(() => {
    if (process.env.REACT_APP_COUNTRY === "svn") {
      document.title = "Cineplexx | Najem"
    }

    return () => {
      document.title = "Cineplexx"
    };

  }, [])

  useEffect(() => {
    if (cinemaRentDetails[0]?.id) {
      setRentDetails(cinemaRentDetails[0]);
    }
  }, [cinemaRentDetails]);

  const languageContents = useMemo(
    () => ({
      headline1: language === 'en' ? 'headline1EN' : 'headline1',
      description: language === 'en' ? 'descriptionEN' : 'description',
      headline2: language === 'en' ? 'headline2EN' : 'headline2',
      Title: language === 'en' ? 'TitleEN' : 'Title',
      Description: language === 'en' ? 'DescriptionEN' : 'Description',
      headline3: language === 'en' ? 'Headline3EN' : 'headline3',
      description3: language === 'en' ? 'description3EN' : 'description3',
      headlinePartner: language === 'en' ? 'headlinePartnerEN' : 'headlinePartner',
      aGBLinktext: language === 'en' ? 'aGBLinktextEN' : 'aGBLinktext',
      b2BLinktext: language === 'en' ? 'b2BLinkTextEN' : 'b2BLinktext'
    }),
    [language]
  );

  const setExpandCb = useCallback(
    id => {
      const expandList = [...isExpanded];

      if (expandList.includes(id)) {
        expandList.splice(expandList.indexOf(id), 1);
      } else {
        expandList.push(id);
      }

      setIsExpanded(expandList);
    },
    [isExpanded]
  );

  const setGiftcardsExpandCb = useCallback(() => {
    setGiftcardsExpanded(prev => !prev);
  }, [giftcardsExpanded]);

  const sliderProps = useMemo(() => sliderPropsConfig(), []);

  return (
    <Container>
      {rentDetails?.headline1 && (
        <>
          <Title>{t('common.cinema_rent')}</Title>
          <CinemaRentWrapper isExpanded={isExpanded}>
            <div className="cinema-rent__subtitle">{rentDetails?.[languageContents.headline1]}</div>
            {rentDetails?.galleryPictures?.length > 0 && (
              <div className="cinema-rent__carousel-wrapper">
                <Carousel
                  {...sliderProps}
                  refEl={sliderRef}
                  className="cinema-rent__carousel"
                  customDot={<CustomImageDot images={rentDetails?.galleryPictures} />}
                >
                  {rentDetails?.galleryPictures?.map((item, index) => (
                    <div key={index}>
                      <Image src={item} className="cinema-rent__carousel-image" />
                    </div>
                  ))}
                </Carousel>
              </div>
            )}
            <div className="cinema-rent__description">
              {parse(rentDetails?.[languageContents.description])}
            </div>
            <div className="cinema-rent__faq-wrapper">
              <h2>{rentDetails?.[languageContents.headline2]}</h2>
              <div className="cinema-rent__faq-container">
                {rentDetails?.faq?.map((item, index) => (
                  <FaqItem key={index} className="cinema-rent__faq-item" isExpanded={isExpanded}>
                    <TriggerCinemaRentInfo
                      isExpanded={isExpanded.includes(index)}
                      onClick={() => setExpandCb(index)}
                      className='cinemaRent'
                    >
                      <Image src={item?.Picture2} className="cinema-rent__faq-item-image" />
                      <div className="cinema-rent__faq-content-wrapper">
                        <h2>{item?.[languageContents.Title]}</h2>
                        <Trigger
                          className="cinema-rent__faq-content-accordion"
                          isExpanded={isExpanded.includes(index)}
                          onClick={() => setExpandCb(index)}
                        >
                          <span className="_with-chevron" />
                        </Trigger>
                      </div>
                      <Expander isExpanded={isExpanded.includes(index)}>
                        <div className="cinema-rent__faq-item-expand-content">
                          {parse(item?.[languageContents.Description])}
                        </div>
                      </Expander>
                    </TriggerCinemaRentInfo>
                  </FaqItem>
                ))}
              </div>
            </div>
            <div className="cinema-rent__giftcards-wrapper">
              <h2>{t('common.giftcards')}:</h2>
              <div className="cinema-rent__giftcards-container">
                <Image src={rentDetails.picture3} />
                <div className="cinema-rent__giftcard-content-wrapper">
                  <h2>{rentDetails?.[languageContents.headline3]}</h2>
                  <Trigger
                    className=""
                    isExpanded={giftcardsExpanded}
                    onClick={() => setGiftcardsExpandCb()}
                  >
                    <span className="_with-chevron" />
                  </Trigger>
                </div>
                <GiftcardExpander isExpanded={giftcardsExpanded}>
                  <div className="cinema-rent__giftcards-expand-content">
                    {parse(rentDetails?.[languageContents.description3])}
                  </div>
                </GiftcardExpander>
              </div>
            </div>
            <div className="cinema-rent__partners-wrapper">
              {rentDetails?.headlinePartner && <h2>{rentDetails?.[languageContents.headlinePartner]}:</h2>}
              <Image src={rentDetails?.partnerImage} />
            </div>
            <div className="cinema-rent__divider" />
            <div className="cinema-rent__inquiry-wrapper">
              <div className="cinema-rent__inquiry-content">
                <h2>{t('common.forward_inqury')}</h2>
                <div className="cinema-rent__inquiry-address-wrapper">
                  <h3 className="cinema-rent__inquiry-title">{t('common.cineplexx_address1')}</h3>
                  <h3>{t('common.cineplexx_address2')}</h3>
                  <h3>{t('common.cineplexx_address3')}</h3>
                  <h3>{t('common.cineplexx_address4')}</h3>
                </div>
                <div className="cinema-rent__inquiry-contact-wrapper">
                  {!restrictedCountries.includes(process.env.REACT_APP_COUNTRY) &&
                    <h3>
                      <b>{t('common.telephone')}:</b> <span className="cinema-rent__inquiry-contact-red-link" onClick={() => document.location.href = `tel:${t('common.telephone_number')}`}>{t('common.telephone_number')}</span>
                    </h3>
                  }
                  <h3>
                    <b>{t('common.email-address')}:</b>{' '}
                    <a
                      href={`mailto:${t('common.sales_email')}`}
                      className="cinema-rent__inquiry-contact-red-link"
                    >
                      {t('common.sales_email')}
                    </a>
                  </h3>
                  <NavLink to={generatePath(routes.cinemaRentInquiry.pattern)}>
                    <Button className="cinema-rent__inquiry-contact-inquiry-btn" isPrimary>
                      {t('common.to_inquiry_form')}
                    </Button>
                  </NavLink>
                  <div>
                    <a href={rentDetails?.aGBPDF} target="_blank" rel="noopener noreferrer">
                      <h3 className="cinema-rent__inquiry-contact-terms">
                        {rentDetails?.[languageContents.aGBLinktext]}
                      </h3>
                    </a>
                  </div>
                </div>
              </div>
              {process.env.REACT_APP_COUNTRY !== "alb" ? (
                <div className="cinema-rent__newsletter-content">
                  <h2>{t('common.b2b_newsletter')}</h2>
                  <h3>{t('common.b2b_newsletter_subtitle')}</h3>
                  <NavLink to={routes.newsletterRegisrationForCinemaRent.pattern}>
                    <Button className="cinema-rent__newsletter-content-btn" isPrimary>
                      {t('common.newsletter_subscribe')}
                    </Button>
                  </NavLink>
                  <div style={{ color: '#de1619' }}>
                    <a href={rentDetails?.b2BPDF} target="_blank" rel="noopener noreferrer">
                      <h3 className="cinema-rent__inquiry-contact-image-folder">
                        {rentDetails?.[languageContents?.b2BLinktext]}
                      </h3>
                    </a>
                  </div>
                </div>
              ) : null}
            </div>
          </CinemaRentWrapper>
        </>
      )}
    </Container>
  );
};

CinemaRent.propTypes = propTypes;
CinemaRent.defaultProps = defaultProps;

export default CinemaRent;
